export const getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};
